import { createAction } from 'redux-actions';

export const failedPendingApplicationRequest = createAction('FAILED_PENDING_APPLICATION_REQUEST');
